import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step4 } from '../../../../../shared/models/component-messages/simp_in/step4';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Initial } from '../../models/Initial';

@Component({
	selector: 'app-step4',
	templateUrl: './step4.component.html'
})
export class Step4Component implements OnInit {
	@Input() fnSimpleInitial: Initial;
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;
	public step4 = new Step4();

	constructor(public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService) {}

	public ngOnInit() {}

	public getUid() {
		return this.uid;
	}
}
